import React from 'react';
import {
  ReviewDataWrapper,
  ReviewCommentWrapper,
  ReviewerNameWrapper,
  ReplyCommentWrapper,
  ReviewerApplyNameWrapper,
  StyledOpacityWrapper,
  ReviewCardContainer,
} from './styled';
import { CommentWriter } from '../../../components/comment-writer';
import { FormattedDate } from '../../../components/formated-date';
import CollapseText from '../../../components/collapse-text';
import { Review } from '../../../typings/reviews';
import FiveStars from '../../../components/five-stars';
import { getRatingPercent } from '../../../utils/general';
import { AppConstants } from '../../../utils/app-constants';

interface ReviewExtendedCardProps {
  review: Review;
  minHeight?: number;
  opacity?: boolean;
  onHandleChangeTracking: (state: boolean) => void;
}
const ReviewExtendedCard: React.FC<ReviewExtendedCardProps> = (
  props,
): JSX.Element => {
  const { review, opacity, onHandleChangeTracking } = props;

  // Component Constants
  const replyLabel = 'Volkswagen response';
  const starSize = '18px';
  const commentLines = 3;
  const textLineHeight = 1.5; // 24px to em base on 16px

  return (
    <ReviewCardContainer className="Review-card-container">
      <StyledOpacityWrapper isOpacity={opacity} />
      <ReviewerNameWrapper>
        <CommentWriter writer={review.reviewer.displayName} />
      </ReviewerNameWrapper>
      <ReviewDataWrapper>
        <FiveStars
          percent={getRatingPercent(review.rating)}
          starColor={AppConstants.StarColor}
          background={AppConstants.StarBackground}
          starSize={starSize}
        />
        <FormattedDate date={review.created} />
      </ReviewDataWrapper>
      <ReviewCommentWrapper>
        <CollapseText
          text={review.content}
          lines={commentLines}
          lineHeight={textLineHeight}
          noFadeTextWrapper
          setStateContainer={onHandleChangeTracking}
        />
      </ReviewCommentWrapper>
      {review.reply && review.reply.dealer_response_text && (
        <ReplyCommentWrapper>
          <ReviewerApplyNameWrapper>
            <div>
              <CommentWriter writer={replyLabel} />
            </div>
            <FormattedDate date={review.reply.dealer_response_date} />
          </ReviewerApplyNameWrapper>
          <ReviewCommentWrapper>
            <CollapseText
              text={review.reply.dealer_response_text}
              lines={commentLines}
              lineHeight={textLineHeight}
              noFadeTextWrapper
            />
          </ReviewCommentWrapper>
        </ReplyCommentWrapper>
      )}
    </ReviewCardContainer>
  );
};
export default ReviewExtendedCard;
